import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Granite Tile",
        price: 50,
        disprice: 40,
        stock: 20,
        content: "Elevate your floors with the natural elegance of our Granite Tile. Crafted from authentic granite stone, these tiles are built to last and ideal for both indoor and outdoor spaces. With a polished finish and rugged durability, they bring style and strength wherever they’re installed.",
        description: "Our Granite Tile blends natural aesthetics with robust performance. Heat-resistant, scratch-proof, and stain-resistant, it’s a versatile solution for kitchens, bathrooms, patios, and hallways. Available in various finishes, it seamlessly complements any interior or exterior design scheme while standing up to everyday wear.",
        category: ["Granite Tile", "Marble Surface"],
        tags: ["Granite", "Tile", "Surface"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Granite Stone" },
            { id: 2, title: "Finish", content: "Polished Surface" },
            { id: 3, title: "Size", content: "12 x 12 inches" },
            { id: 4, title: "Application", content: "Indoor & Outdoor" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Olivia Bennett",
                date: "Jan 14, 2025",
                rating: 4.5,
                content: "The granite tiles added a luxurious finish to my entryway. They're super easy to clean and look stunning."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Foster",
                date: "Feb 03, 2025",
                rating: 5,
                content: "High-quality granite and beautifully polished. Used these in my outdoor kitchen and they exceeded expectations."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Cobble Stone",
        price: 35,
        disprice: 28,
        stock: 50,
        content: "Add old-world charm and unmatched durability to your outdoor spaces with our Cobble Stones. These stones are ideal for walkways, patios, and driveways, delivering a classic look with a rugged, weather-resistant surface.",
        description: "Cobble Stone offers timeless appeal with its naturally textured surface and enduring strength. Perfect for creating rustic walkways, charming courtyards, or stylish garden paths, these stones withstand harsh weather conditions and heavy foot traffic. Available in a variety of shapes and shades to match traditional or contemporary landscapes.",
        category: ["Cobble Stone", "Brick Pavers"],
        tags: ["Cobble", "Stone", "Surface"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Stone" },
            { id: 2, title: "Finish", content: "Rough Textured Surface" },
            { id: 3, title: "Size", content: "Varied Sizes (4 x 4 in, 6 x 6 in)" },
            { id: 4, title: "Application", content: "Outdoor Walkways & Patios" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Sophia Martin",
                date: "Feb 21, 2025",
                rating: 5,
                content: "These cobble stones gave my backyard a rustic European vibe. Installation was easy and the quality is excellent."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "James Carter",
                date: "Mar 10, 2025",
                rating: 4,
                content: "Very durable and looks great in my front driveway. A few pieces varied slightly in shape, but it added to the charm."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Hardwood",
        price: 80,
        disprice: 65,
        stock: 35,
        content: "Bring timeless warmth and rich character to your interiors with our premium Hardwood flooring. Known for its natural grain, durability, and elegant finish, it's a top choice for living rooms, bedrooms, and offices.",
        description: "Our Hardwood flooring combines classic beauty with lasting strength. Crafted from high-grade timber, it offers superior resistance to daily wear while aging gracefully over time. Perfect for creating cozy, refined spaces, this flooring is available in a variety of wood types, finishes, and plank sizes to suit your style preferences.",
        category: ["Wood Flooring", "Marble Surface"],
        tags: ["Wood", "Surface", "Tile"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Hardwood Timber" },
            { id: 2, title: "Finish", content: "Matte or Glossy Options" },
            { id: 3, title: "Size", content: "5 x 48 inches (varies by type)" },
            { id: 4, title: "Application", content: "Indoor Residential & Commercial" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Emma Brooks",
                date: "Mar 25, 2025",
                rating: 5,
                content: "The hardwood flooring completely transformed our living space. It’s warm, rich, and feels incredibly solid underfoot."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Liam Turner",
                date: "Apr 07, 2025",
                rating: 4.5,
                content: "Excellent finish and grain pattern. Installation was straightforward and the quality is premium-grade."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Marble Tile",
        price: 70,
        disprice: 58,
        stock: 25,
        content: "Infuse your spaces with elegance and sophistication using our exquisite Marble Tiles. Known for their natural veining and smooth finish, these tiles are perfect for luxurious floors, walls, and countertops.",
        description: "Our Marble Tile offers a refined, classic aesthetic combined with remarkable durability. Resistant to heat and scratches, it’s ideal for bathrooms, kitchens, and grand entryways. Available in a variety of colors and finishes, it adds a timeless touch to any design, enhancing both modern and traditional interiors.",
        category: ["Marble Surface", "Granite Tile"],
        tags: ["Marble", "Tile", "Surface"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Marble Stone" },
            { id: 2, title: "Finish", content: "Polished or Honed Surface" },
            { id: 3, title: "Size", content: "16 x 16 inches" },
            { id: 4, title: "Application", content: "Indoor Flooring & Walls" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Isabella White",
                date: "Apr 12, 2025",
                rating: 5,
                content: "The marble tiles brought a stunning, luxurious look to my bathroom remodel. They’re smooth, elegant, and easy to maintain."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Ethan Gray",
                date: "Apr 22, 2025",
                rating: 4.5,
                content: "Beautiful finish and excellent quality. Perfect for my kitchen backsplash and flooring."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Brick Pavers",
        price: 25,
        disprice: 20,
        stock: 100,
        content: "Create charming and durable outdoor surfaces with our Brick Pavers. Ideal for patios, walkways, and driveways, these pavers offer classic appeal with long-lasting strength.",
        description: "Our Brick Pavers combine traditional brick aesthetics with superior durability. Resistant to weathering and heavy use, they are perfect for enhancing outdoor spaces such as garden paths, patios, and driveways. Available in various colors and shapes to complement any landscaping style.",
        category: ["Brick Pavers", "Cobble Stone"],
        tags: ["Brick", "Paver", "Stone"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Clay Brick" },
            { id: 2, title: "Finish", content: "Textured Surface" },
            { id: 3, title: "Size", content: "4 x 8 inches" },
            { id: 4, title: "Application", content: "Outdoor Patios & Walkways" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Mia Johnson",
                date: "May 01, 2025",
                rating: 5,
                content: "These brick pavers transformed my backyard patio with their rich color and sturdy feel. Very satisfied!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Noah Williams",
                date: "May 10, 2025",
                rating: 4.5,
                content: "Good quality pavers, easy to lay and perfect for my garden path."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Slate Tile",
        price: 55,
        disprice: 47,
        stock: 30,
        content: "Elevate your floors and walls with our natural Slate Tiles, prized for their rich texture and earthy tones. Perfect for adding a rustic yet refined look to any space.",
        description: "Slate Tile offers a durable, slip-resistant surface with a distinctive layered appearance. Ideal for indoor flooring, wall cladding, and outdoor patios, slate combines natural beauty with high resistance to moisture and wear. Available in multiple colors and finishes to suit a variety of design styles.",
        category: ["Granite Tile", "Marble Surface"],
        tags: ["Slate", "Tile", "Surface"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Slate Stone" },
            { id: 2, title: "Finish", content: "Honed or Natural Cleated" },
            { id: 3, title: "Size", content: "12 x 12 inches" },
            { id: 4, title: "Application", content: "Indoor Flooring & Outdoor Patios" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ava Wilson",
                date: "May 15, 2025",
                rating: 5,
                content: "The slate tiles bring a beautiful natural texture to my kitchen floor. They’re durable and easy to clean."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Ethan Miller",
                date: "May 20, 2025",
                rating: 4.5,
                content: "Great quality slate with a nice natural finish. Perfect for both indoor and outdoor use."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Artificial Turf",
        price: 30,
        disprice: 25,
        stock: 75,
        content: "Enjoy lush, green lawns year-round with our premium Artificial Turf. Low maintenance and durable, it’s perfect for gardens, playgrounds, and sports fields.",
        description: "Our Artificial Turf delivers the vibrant look of natural grass without the upkeep. Made from high-quality synthetic fibers, it’s UV resistant, weatherproof, and ideal for both residential and commercial applications. Easy to install and maintain, it provides a soft, safe surface for all your outdoor needs.",
        category: ["Wood Flooring", "Brick Pavers"],
        tags: ["Surface", "Wood", "Tile"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Synthetic Polyethylene Fibers" },
            { id: 2, title: "Pile Height", content: "1.5 inches" },
            { id: 3, title: "Backing", content: "Perforated Latex" },
            { id: 4, title: "Application", content: "Gardens, Playgrounds, Sports Fields" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Sophia Green",
                date: "May 28, 2025",
                rating: 5,
                content: "The artificial turf looks incredibly natural and is perfect for my kids’ play area. Easy to clean and maintain."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Michael Adams",
                date: "Jun 02, 2025",
                rating: 4.5,
                content: "Great quality turf with excellent durability. Installed it in my backyard and love the lush green look all year."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Concrete Brick",
        price: 18,
        disprice: 15,
        stock: 150,
        content: "Strong and versatile, our Concrete Bricks are ideal for construction and landscaping projects. Designed to provide excellent durability and a modern look.",
        description: "Our Concrete Bricks offer superior strength and weather resistance, making them perfect for building walls, patios, and walkways. They come in various sizes and finishes to meet different architectural needs, providing a cost-effective and reliable solution.",
        category: ["Brick Pavers", "Cobble Stone"],
        tags: ["Brick", "Surface", "Stone"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Reinforced Concrete" },
            { id: 2, title: "Finish", content: "Smooth or Textured" },
            { id: 3, title: "Size", content: "8 x 4 x 2 inches" },
            { id: 4, title: "Application", content: "Walls, Patios, Walkways" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Lucas Martin",
                date: "Jun 05, 2025",
                rating: 5,
                content: "Excellent concrete bricks that stand up well to weather and heavy use. Perfect for my garden walls."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Chloe Ramirez",
                date: "Jun 10, 2025",
                rating: 4.5,
                content: "Great quality and easy to work with. Ideal for my DIY patio project."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Deck Tile",
        price: 35,
        disprice: 29,
        stock: 50,
        content: "Enhance your outdoor living spaces with our stylish and durable Deck Tiles. Easy to install and designed for weather resistance, perfect for patios, balconies, and terraces.",
        description: "Our Deck Tiles combine functionality and aesthetics with a slip-resistant surface and robust construction. Made from premium materials, they withstand the elements while providing a comfortable and attractive flooring solution. Ideal for creating a cozy outdoor environment.",
        category: ["Wood Flooring", "Granite Tile"],
        tags: ["Wood", "Tile", "Surface"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Composite Wood & Plastic" },
            { id: 2, title: "Finish", content: "Textured, Slip-Resistant" },
            { id: 3, title: "Size", content: "12 x 12 inches" },
            { id: 4, title: "Application", content: "Patios, Balconies, Terraces" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Emma Thompson",
                date: "Jun 15, 2025",
                rating: 5,
                content: "These deck tiles are a game-changer for my balcony space. Easy to install and they look fantastic!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "James Carter",
                date: "Jun 20, 2025",
                rating: 4.5,
                content: "Durable and stylish deck tiles that hold up well in all weather conditions."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Granite Slab",
        price: 150,
        disprice: 130,
        stock: 15,
        content: "Elevate your countertops and surfaces with our premium Granite Slabs. Known for their stunning appearance and durability, perfect for kitchens and bathrooms.",
        description: "Our Granite Slabs offer unmatched strength and natural beauty, resistant to heat, scratches, and stains. Ideal for countertops, vanity tops, and tabletops. Available in a variety of colors and finishes to complement any décor.",
        category: ["Granite Tile", "Marble Surface"],
        tags: ["Granite", "Surface", "Stone"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Granite Stone" },
            { id: 2, title: "Finish", content: "Polished or Matte" },
            { id: 3, title: "Size", content: "96 x 26 inches" },
            { id: 4, title: "Application", content: "Countertops & Tabletops" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Isabella Harris",
                date: "Jun 25, 2025",
                rating: 5,
                content: "The granite slab gave my kitchen a luxurious and durable surface. Highly recommend!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "William Scott",
                date: "Jun 30, 2025",
                rating: 4.8,
                content: "Beautiful finish and very sturdy. The slab was easy to install and maintain."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Cobble Paver",
        price: 45,
        disprice: 38,
        stock: 60,
        content: "Create charming, durable outdoor spaces with our Cobble Pavers. Their classic look and strong composition make them ideal for driveways, walkways, and patios.",
        description: "Our Cobble Pavers are crafted from high-quality natural stone, offering excellent durability and resistance to weathering. Perfect for enhancing the aesthetic appeal of any outdoor area while providing a stable, slip-resistant surface. Available in various shapes and colors to complement your landscaping.",
        category: ["Cobble Stone", "Brick Pavers"],
        tags: ["Cobble", "Paver", "Stone"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Stone" },
            { id: 2, title: "Finish", content: "Rough Cut Surface" },
            { id: 3, title: "Size", content: "6 x 6 inches (average)" },
            { id: 4, title: "Application", content: "Driveways, Walkways, Patios" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Mia Collins",
                date: "Jul 02, 2025",
                rating: 5,
                content: "Cobble pavers transformed my driveway into a beautiful, classic space. Very durable and easy to maintain."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Noah Brooks",
                date: "Jul 07, 2025",
                rating: 4.7,
                content: "Great quality pavers that look natural and hold up well under heavy traffic."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Wood Flooring",
        price: 60,
        disprice: 52,
        stock: 40,
        content: "Add warmth and elegance to any room with our premium Wood Flooring. Durable and timeless, perfect for both modern and classic interiors.",
        description: "Our Wood Flooring features high-quality hardwood planks that are strong, scratch-resistant, and easy to maintain. Available in a variety of finishes and wood species to suit your design preferences. Ideal for living rooms, bedrooms, and commercial spaces looking for a natural aesthetic.",
        category: ["Wood Flooring", "Granite Tile"],
        tags: ["Wood", "Surface", "Tile"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Hardwood" },
            { id: 2, title: "Finish", content: "Matte or Glossy" },
            { id: 3, title: "Size", content: "48 x 6 inches (plank)" },
            { id: 4, title: "Application", content: "Residential & Commercial Flooring" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Ava Mitchell",
                date: "Jul 10, 2025",
                rating: 5,
                content: "Beautiful wood flooring that adds a cozy, elegant feel to my home. Very durable and easy to clean."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Ethan Turner",
                date: "Jul 14, 2025",
                rating: 4.8,
                content: "Great quality hardwood flooring. The finish is perfect and installation was straightforward."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Marble Surface",
        price: 140,
        disprice: 125,
        stock: 25,
        content: "Add elegance and sophistication to your interiors with our exquisite Marble Surfaces. Perfect for countertops, flooring, and decorative accents.",
        description: "Our Marble Surfaces are crafted from premium natural marble, offering a smooth, polished finish with unique veining. Highly durable and resistant to heat and scratches, ideal for kitchens, bathrooms, and luxurious living spaces. Available in various colors and finishes to enhance your décor.",
        category: ["Marble Surface", "Granite Tile"],
        tags: ["Marble", "Surface", "Stone"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Marble Stone" },
            { id: 2, title: "Finish", content: "Polished or Honed" },
            { id: 3, title: "Size", content: "96 x 26 inches" },
            { id: 4, title: "Application", content: "Countertops, Flooring, Accents" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Sophia Lee",
                date: "Jul 18, 2025",
                rating: 5,
                content: "The marble surface added a luxurious touch to my bathroom vanity. Stunning and durable!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Liam Parker",
                date: "Jul 22, 2025",
                rating: 4.7,
                content: "Beautiful finish and strong material. Perfect for my kitchen countertops."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Brick Stone",
        price: 30,
        disprice: 25,
        stock: 80,
        content: "Classic and sturdy Brick Stones perfect for creating timeless walls, pathways, and outdoor features.",
        description: "Our Brick Stones offer durability and a rustic charm that enhances both traditional and contemporary designs. Made from high-quality clay and fired to ensure strength and weather resistance. Ideal for landscaping, garden walls, patios, and facades.",
        category: ["Brick Pavers", "Cobble Stone"],
        tags: ["Brick", "Stone", "Surface"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Fired Clay" },
            { id: 2, title: "Finish", content: "Textured Surface" },
            { id: 3, title: "Size", content: "8 x 4 x 2.25 inches" },
            { id: 4, title: "Application", content: "Walls, Pathways, Patios" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Charlotte Evans",
                date: "Jul 25, 2025",
                rating: 4.8,
                content: "These brick stones gave my garden wall a beautiful, classic look. Very sturdy and weatherproof."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Benjamin Scott",
                date: "Jul 30, 2025",
                rating: 4.5,
                content: "Great quality bricks that are easy to work with and look fantastic."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Slate Surface",
        price: 90,
        disprice: 80,
        stock: 30,
        content: "Enhance your interiors with our elegant and durable Slate Surfaces, perfect for flooring, countertops, and wall cladding.",
        description: "Our Slate Surfaces offer a natural, textured finish with excellent durability and resistance to scratches and heat. Ideal for both residential and commercial applications. Available in various shades and finishes to complement any design aesthetic.",
        category:["Marble Surface", "Granite Tile"],
        tags: ["Slate", "Surface", "Stone"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Slate Stone" },
            { id: 2, title: "Finish", content: "Honed or Natural Cleat" },
            { id: 3, title: "Size", content: "24 x 24 inches" },
            { id: 4, title: "Application", content: "Flooring, Countertops, Wall Cladding" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Emily Johnson",
                date: "Aug 05, 2025",
                rating: 5,
                content: "Slate surfaces brought a sophisticated and natural look to my living room floor. Very happy with the quality."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Michael Brown",
                date: "Aug 10, 2025",
                rating: 4.7,
                content: "Great material that’s durable and stylish. Installation was smooth and the finish looks amazing."
            }
        ]
    }

];

export default products;